import React from 'react';

import { Box, HelpCircleIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const TOOLTIP_MESSAGE = `
  Filters by the integration revision currently deployed to a pipeline.
  If a pipeline has a different revision staged (but not yet deployed), the filter will show pipelines with the staged revision instead.
`;

export default function IntegrationSelectTooltip() {
  return (
    <Box display="flex" alignItems="top">
      <WithTooltip show title={TOOLTIP_MESSAGE}>
        <HelpCircleIcon fontSize="small" color="secondary" />
      </WithTooltip>
    </Box>
  );
}
